import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { setConfig } from '@commerce/core'
import { loadConfig } from './config/loadConfig'
import { toPromotionConfig } from './config/toPromotionConfig'
import { AppProviders, store } from './providers/AppProviders'
import { App } from './App'

const slug = window.location.pathname.split('/').filter(Boolean)[0] ?? 'default'
const container = document.getElementById('root')
if (!container) throw new Error('#root not found')
const root = createRoot(container)

loadConfig(slug)
  .then(({ config, tokens }) => {
    // Dispatched before the first render, not in an effect: the promotion
    // engine reads `config.texts.promotions.*` while the catalog is being
    // mapped, so a config that arrives one render late means a first paint with
    // every promotion badge missing. This is also what makes the config slice's
    // `hidePricesActive` derivable at all — it needs the authored rule in place
    // before session data lands.
    store.dispatch(setConfig(toPromotionConfig(config)))

    root.render(
      <StrictMode>
        <AppProviders tokens={tokens} config={config}>
          <App />
        </AppProviders>
      </StrictMode>,
    )
  })
  .catch((error: unknown) => {
    // Config errors are developer-facing and must be loud, not swallowed.
    root.render(<pre style={{ padding: 16 }}>{String(error)}</pre>)
  })
